import React, { useContext, SyntheticEvent, useState } from 'react'
import { uniqueId } from 'lodash'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import FieldTitle from './field-title'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import CreationToolGradient from '../../../types/gradient'
import { STILL_MIME_TYPES } from '../../../constants'
import { GradientButton } from '../../buttons'
import DotsLoader from 'shared/components/loaders/dots'
import downsizeWatermark from '../../../utils/get-downsized-watermark'

const Container = styled.div`
    grid-column: span 2;
`

const FileButton = styled(GradientButton)`
    height: 36px;
    margin-right: 30px;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureWatermarkFileField = ({ field }: Props) => {
    const { setWatermark, setPreviousWatermarks, setIsWatermarkOpen } = useContext(CreationCaptureInfoContext)
    const [isLoading, setIsLoading] = useState(false)

    const onFileInput = async (e: SyntheticEvent<HTMLInputElement, Event>) => {
        const { files } = e.currentTarget
        if (files) {
            setIsLoading(true)
            const base64Watermark = await downsizeWatermark(files[0])
            const newWatermark = { title: files[0].name, image: base64Watermark, id: uniqueId('watermark') }
            setWatermark(newWatermark)
            setIsLoading(false)
            setPreviousWatermarks([newWatermark])
            // TODO: Uncomment once previous watermarks is enabled.
            // setPreviousWatermarks([...previousWatermarks, newWatermark])
            // TODO: Remove once previous watermarks is enabled.
            setIsWatermarkOpen(false)
        }
    }

    return (
        <Container>
            {isLoading ? (
                <DotsLoader />
            ) : (
                <>
                    <FieldTitle field={field} />
                    <FileButton colors={CreationToolGradient.colors(CreationToolGradient.IndigoPurple)}>
                        Choose a File
                        <input type="file" accept={STILL_MIME_TYPES.join(',')} onInput={onFileInput} />
                    </FileButton>
                </>
            )}
        </Container>
    )
}

export default CreationCaptureWatermarkFileField
